import { render, staticRenderFns } from "./DialogRelationBankAccount.vue?vue&type=template&id=d4e4eb0c"
import script from "./DialogRelationBankAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogRelationBankAccount.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports